import { getJsonAsync } from '@digabi/fetch'
import { ExamStatistics } from '../../types'
import { tokenUtils } from './token-utils'

export async function getAbittiExamStatistics({
  startWeek,
}: {
  startWeek: string
}): Promise<ExamStatistics[]> {
  const token = tokenUtils.getValidToken()

  return getJsonAsync(`/api/abitti-exam-statistics?startWeek=${startWeek}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
